import React from 'react';
import { Download, RefreshCw, Waves } from 'lucide-react';
import { logger } from '../../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('Error Boundary caught an error', {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[calc(100svh-6rem)] w-full items-start justify-center overflow-hidden bg-[#020817] px-3 pb-16 pt-6 text-white sm:items-center sm:px-4 sm:py-10">
          <div className="relative w-full max-w-xl rounded-3xl border border-eduvibe-blue/25 bg-[#061832]/92 p-5 text-center shadow-[0_26px_80px_rgba(0,0,0,0.38)] backdrop-blur sm:p-8">
            <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl border border-eduvibe-green/30 bg-eduvibe-green/10 text-eduvibe-green">
              <Waves className="h-8 w-8" aria-hidden="true" />
            </div>
            <h2 className="text-2xl font-black text-white sm:text-3xl">The beat dropped for a second.</h2>
            <p className="mx-auto mt-3 max-w-md text-sm font-medium text-white/70">
              Refresh the app shell, or jump into downloaded songs if your connection is being weird.
            </p>
            <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
              <button
                type="button"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-eduvibe-green px-5 py-3 text-sm font-black text-eduvibe-dark transition hover:bg-eduvibe-blue"
              >
                <RefreshCw className="h-4 w-4" aria-hidden="true" />
                Try again
              </button>
              <button
                type="button"
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.assign('/offline');
                }}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-eduvibe-green/35 px-5 py-3 text-sm font-black text-eduvibe-green transition hover:bg-eduvibe-green hover:text-eduvibe-dark"
              >
                <Download className="h-4 w-4" aria-hidden="true" />
                Downloaded songs
              </button>
            </div>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = `${window.location.origin}${window.location.pathname}?refresh=${Date.now()}`;
              }}
              className="mt-4 text-xs font-bold text-white/50 underline decoration-white/20 underline-offset-4 transition hover:text-white"
            >
              Still stuck? Force a fresh load.
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
